import { Card } from '../../../components/Card';
import {
  IAvailableQuiz,
  IAnsweredQuizPerformance,
} from '../../../interfaces/IPlayerPerformance';

interface PointsOriginProps {
  availableQuizzes: IAvailableQuiz[];
  answeredQuizzes: IAnsweredQuizPerformance[];
}

export function PointsOrigin({
  availableQuizzes,
  answeredQuizzes,
}: PointsOriginProps) {
  return (
    <div className="mb-3">
      <Card shadow>
        <h6 className="fw-semibold mb-3">Origem dos meus pontos</h6>
        <div className="d-flex gap-2" style={{ overflowX: 'auto' }}>
          {availableQuizzes?.map((quiz) => {
            const answered = answeredQuizzes?.find(
              (aq) => aq.actionId === quiz.actionId
            );
            const percentage = answered?.accuracyPercentage || 0;
            const barMaxHeight = 120;
            const barHeight = Math.max((percentage / 100) * barMaxHeight, 4);

            return (
              <div
                key={quiz.actionId}
                className="d-flex flex-column align-items-center"
                style={{ minWidth: '60px', flex: '1 1 0' }}
              >
                <div
                  style={{
                    height: `${barMaxHeight}px`,
                    display: 'flex',
                    alignItems: 'flex-end',
                    width: '100%',
                  }}
                >
                  <div
                    className="w-100 rounded-top"
                    style={{
                      height: `${barHeight}px`,
                      backgroundColor:
                        percentage >= 70
                          ? '#198754'
                          : percentage >= 40
                            ? '#ffc107'
                            : '#dc3545',
                      transition: 'height 0.3s ease',
                    }}
                  />
                </div>
                <div
                  className="text-center mt-2"
                  style={{ fontSize: '0.65rem', lineHeight: '1.2' }}
                  title={quiz.actionTitle}
                >
                  <div className="text-muted">
                    {quiz.actionTitle.length > 12
                      ? `${quiz.actionTitle.substring(0, 12)}...`
                      : quiz.actionTitle}
                  </div>
                  <div className="fw-semibold">{Math.round(percentage)}%</div>
                </div>
              </div>
            );
          })}
        </div>
      </Card>
    </div>
  );
}
